
export type ChatMessageResponseAllOfBasicInfoAllOfTwoType = typeof ChatMessageResponseAllOfBasicInfoAllOfTwoType[keyof typeof ChatMessageResponseAllOfBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatMessageResponseAllOfBasicInfoAllOfTwoType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  LINK: 'LINK',
} as const;
